import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { markRouteRenderComplete } from '@/utils/performance';

export function RouteReadyMarker({ children }: { children: ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    markRouteRenderComplete();
  }, [location.pathname, location.search, location.hash]);

  return children;
}
